import React from "react";
import { Box, Container, Typography } from "@mui/material";

import { Telegram, Twitter } from "@mui/icons-material";

import fdiscord from "../Components/images/fdiscord.png";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import logo from "../Components/images/mainlogo.png";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <Box pt={{ md: 10, xs: 3 }} pb={4}>
      <Container>
        <Box textAlign="center">
          <Box component="img" src={logo} alt="alt" width="10%" height="10%" />
          <Typography sx={{ fontSize: { md: "20px", xs: "12px" }, mt: 3 }}>
            Defi Sage
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            alignContent="center"
            gap={4}
            my={4}
            flexWrap="wrap"
          >
            <Typography
              sx={{
                fontSize: { md: "20px", cursor: "pointer", xs: "12px" },
                mt: 3,
              }}
            >
              <NavLink
                to="/"
                style={{ textDecoration: "none", color: "white" }}
              >
                {t("footer.link1")}
              </NavLink>
            </Typography>
            <Typography
              sx={{
                fontSize: { md: "20px", cursor: "pointer", xs: "12px" },
                mt: 3,
              }}
            >
              <NavLink
                to="/whitepaper"
                style={{ textDecoration: "none", color: "white" }}
              >
                {t("footer.link2")}
              </NavLink>
            </Typography>
            <Typography
              sx={{
                fontSize: { md: "20px", cursor: "pointer", xs: "12px" },
                mt: 3,
              }}
            >
              <NavLink
                to="/staking"
                style={{ textDecoration: "none", color: "white" }}
              >
                Dapp
              </NavLink>
            </Typography>
            <Typography
              sx={{
                fontSize: { md: "20px", cursor: "pointer", xs: "12px" },
                mt: 3,
              }}
            >
              <NavLink
                to="#"
                style={{ textDecoration: "none", color: "white" }}
              >
                {t("footer.link3")}
              </NavLink>
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignContent="center"
            gap={4}
            my={4}
            flexWrap="wrap"
          >
            <Typography
              sx={{
                fontSize: {
                  md: "16px",
                  color: "#898989",
                  cursor: "pointer",
                  xs: "10px",
                },
                mt: 3,
              }}
            >
              <NavLink
                to="#"
                style={{ textDecoration: "none", color: "#898989" }}
              >
                Graph Foundation
              </NavLink>
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  md: "16px",
                  color: "#898989",
                  cursor: "pointer",
                  xs: "10px",
                },
                mt: 3,
              }}
            >
              <NavLink
                to="#"
                style={{ textDecoration: "none", color: "#898989" }}
              >
                {" "}
                Privacy Policy
              </NavLink>
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  md: "16px",
                  color: "#898989",
                  cursor: "pointer",
                  xs: "10px",
                },
                mt: 3,
              }}
            >
              <NavLink
                to="#"
                style={{ textDecoration: "none", color: "#898989" }}
              >
                Forum
              </NavLink>
            </Typography>{" "}
            <Typography
              sx={{
                fontSize: {
                  md: "16px",
                  color: "#898989",
                  cursor: "pointer",
                  xs: "10px",
                },
                mt: 3,
              }}
            >
              <NavLink
                to="#"
                style={{ textDecoration: "none", color: "#898989" }}
              >
                Terms of Service
              </NavLink>
            </Typography>{" "}
            <Typography
              sx={{
                fontSize: {
                  md: "16px",
                  color: "#898989",
                  cursor: "pointer",
                  xs: "10px",
                },
                mt: 3,
              }}
            >
              <NavLink
                to="#"
                style={{ textDecoration: "none", color: "#898989" }}
              >
                Testnet
              </NavLink>{" "}
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  md: "16px",
                  color: "#898989",
                  cursor: "pointer",
                  xs: "10px",
                },
                mt: 3,
              }}
            >
              <NavLink
                to="#"
                style={{ textDecoration: "none", color: "#898989" }}
              >
                Partnership Requests
              </NavLink>
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" gap={4}>
            <a
              href="https://discord.com/invite/4YDkgFgq"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={fdiscord}
                alt="fdiscord"
                sx={{ color: "#898989", cursor: "pointer" }}
              />
            </a>
            <a
              href="https://t.me/Defisage"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Telegram sx={{ color: "#898989" }} />
            </a>
            <a
              href="https://twitter.com/Defi_sage_?t=RM3U5q8zjigK_4R1HRMNJw&s=09"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Twitter sx={{ color: "#898989" }} />
            </a>
          </Box>

          <Typography
            sx={{
              fontSize: {
                md: "16px",
                color: "#898989",

                xs: "10px",
              },
              mt: 10,
            }}
          >
            copyright@Defi Sage
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
